import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {ThirdPartyShare} from '../model/social-sharing/thirdPartyShare';
import {TSMap} from 'typescript-map';

@JsonConverter
export class ThirdPartyShareConverter implements JsonCustomConvert<TSMap<string,ThirdPartyShare>> {
    deserialize(json: any): TSMap<string,ThirdPartyShare> {


        // const textMsgArr:Array<ThirdPartyShare> =  [];
        // const temp:TSMap<string,EmailBanner>= new TSMap();

        /*for (const item of json) {
            textMsgArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,ThirdPartyShare));
        }

        return textMsgArr;*/

        const temp:TSMap<string,ThirdPartyShare> = new TSMap();

        /*for (const text of json) {
            temp.set(text[0], text[1]);
        }*/
        for (const key of Object.keys(json)) {
            temp.set(key,Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json[key],ThirdPartyShare));
        }

        return temp;
    }

    serialize(data: TSMap<string,ThirdPartyShare>): any {
        return JSON.stringify(data);
    }
}
